// extracted by mini-css-extract-plugin
module.exports = {"propertiesDialog":"PropertiesDialog_propertiesDialog__1sHep","propertiesWrap":"PropertiesDialog_propertiesWrap__1H8aH"};